var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRewardDetailRupees(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 10C16.6665 6.3181 13.6818 3.33334 9.99984 3.33334C6.31794 3.33334 3.33317 6.3181 3.33317 10C3.33317 13.6819 6.31794 16.6667 9.99984 16.6667C13.6818 16.6667 16.6665 13.6819 16.6665 10ZM18.3332 10C18.3332 14.6023 14.6022 18.3333 9.99984 18.3333C5.39746 18.3333 1.6665 14.6023 1.6665 10C1.6665 5.39763 5.39746 1.66667 9.99984 1.66667C14.6022 1.66667 18.3332 5.39763 18.3332 10ZM11.2501 6.66667C11.523 7.03006 11.7186 7.45487 11.8123 7.91667H13.3332V9.16667H11.8123C11.5228 10.5931 10.2617 11.6667 8.74984 11.6667H8.59209L11.6918 14.7664L10.8079 15.6503L6.6665 11.5089V10.4167H8.74984C9.56625 10.4167 10.2608 9.89492 10.5182 9.16667H6.6665V7.91667H10.5182C10.2608 7.18843 9.56625 6.66667 8.74984 6.66667H6.6665V5.41667H13.3332V6.66667H11.2501Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardDetailRupees);
export default __webpack_public_path__ + "static/media/rewardDetailRupees.559133773367c34076af0dce50cddc59.svg";
export { ForwardRef as ReactComponent };